import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  de: {
    translation: {
      // Navigation
      'nav.dashboard': 'Dashboard',
      'nav.vehicles': 'Fahrzeuge',
      'nav.receipts': 'Belege',
      'nav.schedule': 'Dienstplan',
      'nav.timeTracking': 'Zeiterfassung',
      'nav.chat': 'Chat',
      'nav.payroll': 'Gehaltsabrechnung',
      'nav.vacation': 'Urlaub',
      'nav.staff': 'Mitarbeiter',
      'nav.analytics': 'Statistiken',
      'nav.tenants': 'Mandanten',
      'nav.settings': 'Einstellungen',
      'nav.lexware': 'Lexware Sync',
      'nav.damages': 'Schadensmanagement',
      'nav.logout': 'Abmelden',
      'nav.reportDamage': 'Schaden melden',
      'nav.myPayroll': 'Meine Abrechnungen',
      'nav.shiftPreferences': 'Schichtwünsche',
      'nav.liveTracking': 'Live Tracking',
      'nav.geofencing': 'Geofencing',
      'nav.billing': 'Abrechnung',
      'nav.backup': 'Backup & Export',
      
      // Auth & Login
      'auth.login': 'Anmelden',
      'auth.email': 'E-Mail Adresse',
      'auth.password': 'Passwort',
      'auth.rememberMe': 'Angemeldet bleiben',
      'auth.forgotPassword': 'Passwort vergessen?',
      'auth.noAccount': 'Noch kein Zugang?',
      'auth.register': 'Kostenlos registrieren',
      'auth.demo': 'Demo-Zugang testen',
      'auth.loginSuccess': 'Erfolgreich angemeldet!',
      'auth.loginFailed': 'Login fehlgeschlagen. Bitte E-Mail und Passwort überprüfen.',
      'auth.fillEmailPassword': 'Bitte E-Mail und Passwort eingeben',
      'auth.demoInserted': 'Demo-Zugangsdaten eingefügt',
      'auth.clickToLogin': 'Klicken Sie auf "Anmelden" um fortzufahren',
      'auth.logoutSuccess': 'Erfolgreich abgemeldet',
      'auth.logoutFailed': 'Fehler beim Abmelden',
      
      // Common
      'common.save': 'Speichern',
      'common.cancel': 'Abbrechen',
      'common.delete': 'Löschen',
      'common.edit': 'Bearbeiten',
      'common.add': 'Hinzufügen',
      'common.search': 'Suchen',
      'common.filter': 'Filtern',
      'common.export': 'Exportieren',
      'common.loading': 'Lädt...',
      'common.error': 'Fehler',
      'common.success': 'Erfolg',
      'common.confirm': 'Bestätigen',
      'common.close': 'Schließen',
      
      // Dashboard
      'dashboard.title': 'Dashboard',
      'dashboard.welcome': 'Willkommen',
      'dashboard.vehicles.total': 'Fahrzeuge gesamt',
      'dashboard.vehicles.active': 'Aktive Fahrzeuge',
      'dashboard.vehicles.maintenance': 'In Wartung',
      'dashboard.receipts.total': 'Belege gesamt',
      'dashboard.receipts.pending': 'Ausstehende Belege',
      'dashboard.tuv.expiring': 'TÜV läuft ab',
      'dashboard.myVehicles': 'Meine Fahrzeuge',
      'dashboard.noVehicles': 'Keine Fahrzeuge zugewiesen',
      'dashboard.quickActions': 'Schnellaktionen',
      'dashboard.recentActivities': 'Letzte Aktivitäten',
      'dashboard.status.available': 'Verfügbar',
      'dashboard.status.inUse': 'Im Einsatz',
      'dashboard.status.maintenance': 'Wartung',
      
      // Vehicles
      'vehicles.title': 'Fahrzeuge',
      'vehicles.add': 'Fahrzeug hinzufügen',
      'vehicles.licensePlate': 'Kennzeichen',
      'vehicles.model': 'Modell',
      'vehicles.status': 'Status',
      'vehicles.km': 'Kilometerstand',
      'vehicles.tuv': 'TÜV Ablauf',
      'vehicles.assignedTo': 'Zugewiesen an',
      'vehicles.available': 'Verfügbar',
      'vehicles.inUse': 'Im Einsatz',
      'vehicles.maintenance': 'Wartung',
      
      // Chat & Walkie-Talkie
      'chat.title': 'Team Chat',
      'chat.send': 'Senden',
      'chat.holdToSpeak': 'Halten zum Sprechen',
      'chat.recording': 'Aufnahme...',
      'chat.releaseToSend': 'Loslassen zum Senden',
      'chat.voiceMessage': 'Sprachnachricht',
      'chat.voiceSent': 'Sprachnachricht gesendet',
      
      // Notifications
      'notifications.title': 'Benachrichtigungen',
      'notifications.markAllRead': 'Alle gelesen',
      'notifications.noNotifications': 'Keine Benachrichtigungen',
      'notifications.loading': 'Lade Benachrichtigungen...',
      
      // Time Tracking
      'time.clockIn': 'Einstempeln',
      'time.clockOut': 'Ausstempeln',
      'time.break': 'Pause',
      'time.total': 'Gesamt',
      'time.hours': 'Stunden',
      
      // Errors
      'error.loading': 'Fehler beim Laden',
      'error.saving': 'Fehler beim Speichern',
      'error.network': 'Netzwerkfehler',
      'error.permission': 'Keine Berechtigung',
      'error.microphone': 'Mikrofon-Zugriff verweigert',
      
      // Payment & POS
      'payment.demo.title': 'Nexi SoftPOS Demo',
      'payment.demo.description': 'Test der Kartenzahlung via Nexi SoftPOS',
      'payment.amount': 'Betrag (EUR)',
      'payment.orderId': 'Bestell-ID (Demo)',
      'payment.note': 'Hinweis',
      'payment.demo.note': 'Diese Demo-Seite testet die Nexi SoftPOS Integration.',
      'payment.requirements': 'Voraussetzungen',
      'payment.req.nfc': 'Android-Gerät mit NFC',
      'payment.req.app': 'Nexi POS App installiert',
      'payment.req.internet': 'Internet-Verbindung',
      'payment.start': 'Kartenzahlung starten',
      'payment.backToDashboard': 'Zurück zum Dashboard',
      'payment.success': 'Zahlung erfolgreich!',
      'payment.failed': 'Zahlung fehlgeschlagen',
      'payment.cancelled': 'Zahlung abgebrochen',
      'payment.transactionId': 'Transaktions-ID',
      'payment.deliveryCompleted': 'Lieferung abgeschlossen',
      'payment.errorOccurred': 'Ein Fehler ist aufgetreten',
      
      // Chat
      'chat.title': 'Team Chat',
      'chat.groupChat': 'Gruppen-Chat',
      'chat.branch': 'Filiale',
      'chat.mainBranch': 'Hauptfiliale',
      'chat.inputPlaceholder': 'Nachricht eingeben...',
      'chat.messageSent': 'Nachricht gesendet',
      'chat.sendError': 'Fehler beim Senden der Nachricht',
      'chat.noMessages': 'Keine Nachrichten',
      
      // Time Tracking
      'timeTracking.title': 'Zeiterfassung',
      'timeTracking.clockIn': 'Einstempeln',
      'timeTracking.clockOut': 'Ausstempeln',
      'timeTracking.currentShift': 'Aktuelle Schicht',
      'timeTracking.today': 'Heute',
      'timeTracking.thisWeek': 'Diese Woche',
      'timeTracking.thisMonth': 'Dieser Monat',
      'timeTracking.totalHours': 'Gesamtstunden',
      'timeTracking.workingTime': 'Arbeitszeit',
      'timeTracking.breakTime': 'Pausenzeit',
      'timeTracking.overtime': 'Überstunden',
      'timeTracking.history': 'Verlauf',
      'timeTracking.startTime': 'Startzeit',
      'timeTracking.endTime': 'Endzeit',
      'timeTracking.duration': 'Dauer',
      'timeTracking.status': 'Status',
      'timeTracking.active': 'Aktiv',
      'timeTracking.completed': 'Abgeschlossen',
      
      // Vacation
      'vacation.title': 'Urlaubsantrag',
      'vacation.request': 'Antrag stellen',
      'vacation.myRequests': 'Meine Anträge',
      'vacation.startDate': 'Startdatum',
      'vacation.endDate': 'Enddatum',
      'vacation.days': 'Tage',
      'vacation.reason': 'Grund',
      'vacation.status': 'Status',
      'vacation.pending': 'Ausstehend',
      'vacation.approved': 'Genehmigt',
      'vacation.rejected': 'Abgelehnt',
      'vacation.remainingDays': 'Resturlaub',
      'vacation.usedDays': 'Genommen',
      'vacation.submit': 'Antrag absenden',
      'vacation.submitted': 'Antrag eingereicht',
      'vacation.submitError': 'Fehler beim Einreichen',
      
      // Schedule
      'schedule.title': 'Dienstplan',
      'schedule.thisWeek': 'Diese Woche',
      'schedule.nextWeek': 'Nächste Woche',
      'schedule.myShifts': 'Meine Schichten',
      'schedule.allShifts': 'Alle Schichten',
      'schedule.noShifts': 'Keine Schichten geplant',
      'schedule.morning': 'Frühschicht',
      'schedule.afternoon': 'Spätschicht',
      'schedule.night': 'Nachtschicht',
      
      // Receipts
      'receipts.title': 'Belege',
      'receipts.upload': 'Beleg hochladen',
      'receipts.myReceipts': 'Meine Belege',
      'receipts.date': 'Datum',
      'receipts.amount': 'Betrag',
      'receipts.category': 'Kategorie',
      'receipts.fuel': 'Tankbeleg',
      'receipts.repair': 'Reparatur',
      'receipts.other': 'Sonstiges',
      'receipts.status': 'Status',
      'receipts.pending': 'Ausstehend',
      'receipts.approved': 'Genehmigt',
      'receipts.rejected': 'Abgelehnt',
      'receipts.uploadSuccess': 'Beleg hochgeladen',
      'receipts.uploadError': 'Fehler beim Hochladen',
      
      // Card Payment Flow
      'pos.checking': 'Prüfe Zahlungssystem...',
      'pos.notAvailable': 'Kartenzahlung nicht verfügbar',
      'pos.appNotInstalled': 'Nexi POS App nicht installiert. Bitte installieren Sie die Nexi POS App aus dem Play Store.',
      'pos.useCashAlternative': 'Bitte nutzen Sie Barzahlung als Alternative.',
      'pos.backToCash': 'Zurück zur Barzahlung',
      'pos.cardPayment': 'Kartenzahlung',
      'pos.amountToPay': 'Zu zahlender Betrag',
      'pos.order': 'Bestellung',
      'pos.howItWorks': 'So geht\'s',
      'pos.step1': 'Button "Zahlung starten" drücken',
      'pos.step2': 'Nexi POS öffnet sich automatisch',
      'pos.step3': 'Kunde hält Karte/Handy an Ihr Smartphone',
      'pos.step4': 'Fertig!',
      'pos.startPayment': 'Zahlung starten',
      'pos.cancel': 'Abbrechen',
      'pos.processing': 'Zahlung läuft...',
      'pos.holdCard': 'Bitte Karte oder Handy',
      'pos.holdCardLine2': 'an das Smartphone halten',
      'pos.paymentSuccess': 'Zahlung erfolgreich!',
      'pos.successMessage': 'Die Zahlung wurde erfolgreich verarbeitet. Die Lieferung wird jetzt abgeschlossen.',
      'pos.paymentFailed': 'Zahlung fehlgeschlagen',
      'pos.paymentCancelled': 'Zahlung abgebrochen',
      'pos.cancelledMessage': 'Die Kartenzahlung wurde abgebrochen.',
      'pos.retry': 'Erneut versuchen',
      'pos.switchToCash': 'Zur Barzahlung wechseln',
      
      // Deliveries (Cash-X)
      'deliveries.title': 'Lieferungen',
      'deliveries.activeDeliveries': 'aktive Lieferungen',
      'deliveries.activeDelivery': 'aktive Lieferung',
      'deliveries.scanQR': 'QR scannen',
      'deliveries.scanQRCode': 'QR-Code scannen',
      'deliveries.noActiveDeliveries': 'Keine aktiven Lieferungen',
      'deliveries.scanToPickup': 'Scanne einen QR-Code um eine Lieferung zu übernehmen',
      'deliveries.order': 'Bestellung',
      'deliveries.items': 'Artikel',
      'deliveries.total': 'Gesamt',
      'deliveries.route': 'Route',
      'deliveries.call': 'Anrufen',
      'deliveries.delivered': 'Zugestellt',
      'deliveries.problem': 'Problem',
      'deliveries.loadError': 'Fehler beim Laden der Lieferungen',
      
      // Shift Management
      'shift.noActiveShift': 'Keine aktive Schicht',
      'shift.startAtRestaurant': 'Starte deine Schicht im Restaurant',
      'shift.start': 'Starten',
      'shift.running': 'Schicht läuft',
      'shift.end': 'Beenden',
      'shift.ending': 'Beenden...',
      'shift.started': 'Gestartet',
      'shift.deliveries': 'Lieferungen',
      'shift.mustEndAtRestaurant': 'Schicht muss im Restaurant beendet werden',
      'shift.gpsChecking': 'GPS wird ermittelt...',
      'shift.tooFarFromRestaurant': 'Sie sind zu weit vom Restaurant entfernt',
      'shift.currentDistance': 'Aktuell: {distance} entfernt (max. {radius}m)',
      'shift.scanQR': 'Schicht-QR scannen',
      'shift.scanDescription': 'Scanne den QR-Code im Restaurant',
      'shift.started': 'Schicht gestartet!',
      'shift.ended': 'Schicht beendet!',
      'shift.duration': 'Dauer: {duration} Min',
      'shift.deliveriesCount': '{count} Lieferungen',
      
      // QR Scanner
      'qr.title': 'QR-Code Scanner',
      'qr.startCamera': 'Kamera starten',
      'qr.manualInput': 'Test: Manuell eingeben',
      'qr.scanOrderCode': 'Scanne den QR-Code auf der Bestellung',
      'qr.holdInArea': 'Halte den QR-Code in den markierten Bereich',
      'qr.cameraActive': 'Kamera aktiviert',
      'qr.holdToCamera': 'Halte den QR-Code vor die Kamera',
      'qr.cameraError': 'Kamera-Zugriff fehlgeschlagen',
      'qr.enableInSettings': 'Bitte erlaube den Kamera-Zugriff in den Einstellungen',
      'qr.orderClaimed': 'Lieferung übernommen!',
      'qr.claimError': 'Fehler beim Übernehmen',
      'qr.processing': 'Bestellung wird übernommen...'
    }
  },
  en: {
    translation: {
      // Navigation
      'nav.dashboard': 'Dashboard',
      'nav.vehicles': 'Vehicles',
      'nav.receipts': 'Receipts',
      'nav.schedule': 'Schedule',
      'nav.timeTracking': 'Time Tracking',
      'nav.chat': 'Chat',
      'nav.payroll': 'Payroll',
      'nav.vacation': 'Vacation',
      'nav.staff': 'Staff',
      'nav.analytics': 'Analytics',
      'nav.tenants': 'Tenants',
      'nav.settings': 'Settings',
      'nav.lexware': 'Lexware Sync',
      'nav.damages': 'Damage Management',
      'nav.logout': 'Logout',
      'nav.reportDamage': 'Report Damage',
      'nav.myPayroll': 'My Payroll',
      'nav.shiftPreferences': 'Shift Preferences',
      'nav.liveTracking': 'Live Tracking',
      'nav.geofencing': 'Geofencing',
      'nav.billing': 'Billing',
      'nav.backup': 'Backup & Export',
      
      // Auth & Login
      'auth.login': 'Login',
      'auth.email': 'Email Address',
      'auth.password': 'Password',
      'auth.rememberMe': 'Stay logged in',
      'auth.forgotPassword': 'Forgot password?',
      'auth.noAccount': 'No account yet?',
      'auth.register': 'Register for free',
      'auth.demo': 'Try demo access',
      'auth.loginSuccess': 'Successfully logged in!',
      'auth.loginFailed': 'Login failed. Please check email and password.',
      'auth.fillEmailPassword': 'Please enter email and password',
      'auth.demoInserted': 'Demo credentials inserted',
      'auth.clickToLogin': 'Click "Login" to continue',
      'auth.logoutSuccess': 'Successfully logged out',
      'auth.logoutFailed': 'Error logging out',
      
      // Common
      'common.save': 'Save',
      'common.cancel': 'Cancel',
      'common.delete': 'Delete',
      'common.edit': 'Edit',
      'common.add': 'Add',
      'common.search': 'Search',
      'common.filter': 'Filter',
      'common.export': 'Export',
      'common.loading': 'Loading...',
      'common.error': 'Error',
      'common.success': 'Success',
      'common.confirm': 'Confirm',
      'common.close': 'Close',
      
      // Dashboard
      'dashboard.title': 'Dashboard',
      'dashboard.welcome': 'Welcome',
      'dashboard.vehicles.total': 'Total Vehicles',
      'dashboard.vehicles.active': 'Active Vehicles',
      'dashboard.vehicles.maintenance': 'In Maintenance',
      'dashboard.receipts.total': 'Total Receipts',
      'dashboard.receipts.pending': 'Pending Receipts',
      'dashboard.tuv.expiring': 'TÜV Expiring',
      'dashboard.myVehicles': 'My Vehicles',
      'dashboard.noVehicles': 'No vehicles assigned',
      'dashboard.quickActions': 'Quick Actions',
      'dashboard.recentActivities': 'Recent Activities',
      'dashboard.status.available': 'Available',
      'dashboard.status.inUse': 'In Use',
      'dashboard.status.maintenance': 'Maintenance',
      
      // Vehicles
      'vehicles.title': 'Vehicles',
      'vehicles.add': 'Add Vehicle',
      'vehicles.licensePlate': 'License Plate',
      'vehicles.model': 'Model',
      'vehicles.status': 'Status',
      'vehicles.km': 'Mileage',
      'vehicles.tuv': 'TÜV Expiry',
      'vehicles.assignedTo': 'Assigned To',
      'vehicles.available': 'Available',
      'vehicles.inUse': 'In Use',
      'vehicles.maintenance': 'Maintenance',
      
      // Chat & Walkie-Talkie
      'chat.title': 'Team Chat',
      'chat.send': 'Send',
      'chat.holdToSpeak': 'Hold to Speak',
      'chat.recording': 'Recording...',
      'chat.releaseToSend': 'Release to Send',
      'chat.voiceMessage': 'Voice Message',
      'chat.voiceSent': 'Voice message sent',
      'chat.groupChat': 'Group Chat',
      'chat.branch': 'Branch',
      'chat.mainBranch': 'Main Branch',
      'chat.inputPlaceholder': 'Type a message...',
      'chat.messageSent': 'Message sent',
      'chat.sendError': 'Error sending message',
      'chat.noMessages': 'No messages',
      
      // Time Tracking
      'timeTracking.title': 'Time Tracking',
      'timeTracking.clockIn': 'Clock In',
      'timeTracking.clockOut': 'Clock Out',
      'timeTracking.currentShift': 'Current Shift',
      'timeTracking.today': 'Today',
      'timeTracking.thisWeek': 'This Week',
      'timeTracking.thisMonth': 'This Month',
      'timeTracking.totalHours': 'Total Hours',
      'timeTracking.workingTime': 'Working Time',
      'timeTracking.breakTime': 'Break Time',
      'timeTracking.overtime': 'Overtime',
      'timeTracking.history': 'History',
      'timeTracking.startTime': 'Start Time',
      'timeTracking.endTime': 'End Time',
      'timeTracking.duration': 'Duration',
      'timeTracking.status': 'Status',
      'timeTracking.active': 'Active',
      'timeTracking.completed': 'Completed',
      
      // Vacation
      'vacation.title': 'Vacation Request',
      'vacation.request': 'Submit Request',
      'vacation.myRequests': 'My Requests',
      'vacation.startDate': 'Start Date',
      'vacation.endDate': 'End Date',
      'vacation.days': 'Days',
      'vacation.reason': 'Reason',
      'vacation.status': 'Status',
      'vacation.pending': 'Pending',
      'vacation.approved': 'Approved',
      'vacation.rejected': 'Rejected',
      'vacation.remainingDays': 'Remaining Days',
      'vacation.usedDays': 'Used Days',
      'vacation.submit': 'Submit Request',
      'vacation.submitted': 'Request Submitted',
      'vacation.submitError': 'Error Submitting Request',
      
      // Schedule
      'schedule.title': 'Schedule',
      'schedule.thisWeek': 'This Week',
      'schedule.nextWeek': 'Next Week',
      'schedule.myShifts': 'My Shifts',
      'schedule.allShifts': 'All Shifts',
      'schedule.noShifts': 'No shifts scheduled',
      'schedule.morning': 'Morning Shift',
      'schedule.afternoon': 'Afternoon Shift',
      'schedule.night': 'Night Shift',
      
      // Receipts
      'receipts.title': 'Receipts',
      'receipts.upload': 'Upload Receipt',
      'receipts.myReceipts': 'My Receipts',
      'receipts.date': 'Date',
      'receipts.amount': 'Amount',
      'receipts.category': 'Category',
      'receipts.fuel': 'Fuel Receipt',
      'receipts.repair': 'Repair',
      'receipts.other': 'Other',
      'receipts.status': 'Status',
      'receipts.pending': 'Pending',
      'receipts.approved': 'Approved',
      'receipts.rejected': 'Rejected',
      'receipts.uploadSuccess': 'Receipt uploaded',
      'receipts.uploadError': 'Error uploading receipt',
      
      // Notifications
      'notifications.title': 'Notifications',
      'notifications.markAllRead': 'Mark all read',
      'notifications.noNotifications': 'No notifications',
      'notifications.loading': 'Loading notifications...',
      
      // Time Tracking
      'time.clockIn': 'Clock In',
      'time.clockOut': 'Clock Out',
      'time.break': 'Break',
      'time.total': 'Total',
      'time.hours': 'Hours',
      
      // Errors
      'error.loading': 'Error loading',
      'error.saving': 'Error saving',
      'error.network': 'Network error',
      'error.permission': 'No permission',
      'error.microphone': 'Microphone access denied',
      
      // Payment & POS
      'payment.demo.title': 'Nexi SoftPOS Demo',
      'payment.demo.description': 'Test card payment via Nexi SoftPOS',
      'payment.amount': 'Amount (EUR)',
      'payment.orderId': 'Order ID (Demo)',
      'payment.note': 'Note',
      'payment.demo.note': 'This demo page tests the Nexi SoftPOS integration.',
      'payment.requirements': 'Requirements',
      'payment.req.nfc': 'Android device with NFC',
      'payment.req.app': 'Nexi POS App installed',
      'payment.req.internet': 'Internet connection',
      'payment.start': 'Start card payment',
      'payment.backToDashboard': 'Back to Dashboard',
      'payment.success': 'Payment successful!',
      'payment.failed': 'Payment failed',
      'payment.cancelled': 'Payment cancelled',
      'payment.transactionId': 'Transaction ID',
      'payment.deliveryCompleted': 'Delivery completed',
      'payment.errorOccurred': 'An error occurred',
      
      // Card Payment Flow
      'pos.checking': 'Checking payment system...',
      'pos.notAvailable': 'Card payment not available',
      'pos.appNotInstalled': 'Nexi POS App not installed. Please install the Nexi POS App from the Play Store.',
      'pos.useCashAlternative': 'Please use cash payment as alternative.',
      'pos.backToCash': 'Back to cash payment',
      'pos.cardPayment': 'Card Payment',
      'pos.amountToPay': 'Amount to pay',
      'pos.order': 'Order',
      'pos.howItWorks': 'How it works',
      'pos.step1': 'Press "Start payment" button',
      'pos.step2': 'Nexi POS opens automatically',
      'pos.step3': 'Customer holds card/phone to your smartphone',
      'pos.step4': 'Done!',
      'pos.startPayment': 'Start payment',
      'pos.cancel': 'Cancel',
      'pos.processing': 'Payment in progress...',
      'pos.holdCard': 'Please hold card or phone',
      'pos.holdCardLine2': 'to the smartphone',
      'pos.paymentSuccess': 'Payment successful!',
      'pos.successMessage': 'The payment was processed successfully. The delivery will now be completed.',
      'pos.paymentFailed': 'Payment failed',
      'pos.paymentCancelled': 'Payment cancelled',
      'pos.cancelledMessage': 'The card payment was cancelled.',
      'pos.retry': 'Try again',
      'pos.switchToCash': 'Switch to cash payment',
      
      // Deliveries (Cash-X)
      'deliveries.title': 'Deliveries',
      'deliveries.activeDeliveries': 'active deliveries',
      'deliveries.activeDelivery': 'active delivery',
      'deliveries.scanQR': 'Scan QR',
      'deliveries.scanQRCode': 'Scan QR code',
      'deliveries.noActiveDeliveries': 'No active deliveries',
      'deliveries.scanToPickup': 'Scan a QR code to pick up a delivery',
      'deliveries.order': 'Order',
      'deliveries.items': 'Items',
      'deliveries.total': 'Total',
      'deliveries.route': 'Route',
      'deliveries.call': 'Call',
      'deliveries.delivered': 'Delivered',
      'deliveries.problem': 'Problem',
      'deliveries.loadError': 'Error loading deliveries',
      
      // Shift Management
      'shift.noActiveShift': 'No active shift',
      'shift.startAtRestaurant': 'Start your shift at the restaurant',
      'shift.start': 'Start',
      'shift.running': 'Shift running',
      'shift.end': 'End',
      'shift.ending': 'Ending...',
      'shift.started': 'Started',
      'shift.deliveries': 'Deliveries',
      'shift.mustEndAtRestaurant': 'Shift must be ended at the restaurant',
      'shift.gpsChecking': 'Checking GPS...',
      'shift.tooFarFromRestaurant': 'You are too far from the restaurant',
      'shift.currentDistance': 'Current: {distance} away (max. {radius}m)',
      'shift.scanQR': 'Scan shift QR',
      'shift.scanDescription': 'Scan the QR code at the restaurant',
      'shift.started': 'Shift started!',
      'shift.ended': 'Shift ended!',
      'shift.duration': 'Duration: {duration} min',
      'shift.deliveriesCount': '{count} deliveries',
      
      // QR Scanner
      'qr.title': 'QR Code Scanner',
      'qr.startCamera': 'Start camera',
      'qr.manualInput': 'Test: Manual input',
      'qr.scanOrderCode': 'Scan the QR code on the order',
      'qr.holdInArea': 'Hold the QR code in the marked area',
      'qr.cameraActive': 'Camera activated',
      'qr.holdToCamera': 'Hold the QR code in front of the camera',
      'qr.cameraError': 'Camera access failed',
      'qr.enableInSettings': 'Please enable camera access in settings',
      'qr.orderClaimed': 'Delivery claimed!',
      'qr.claimError': 'Error claiming order',
      'qr.processing': 'Claiming order...'
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage']
    }
  });

export default i18n;
